import Api from "@/services/Api";
import BaseApi from "../../../services/baseApi";
class User_se {
    constructor() {
        this.entity = 'user';
    }

    delete(id) {
        return Api.delete(this.entity,id)
    }


    getById(id) {
        if(id && id.length>0) {
            return Api.getById(this.entity, id)
        }else {
            return Api.new_(this.entity)
        }
    }

    getPage(page_,size_,type,search) {
        let formData=new FormData();
        formData.set("type",type)
        formData.set("search", search)
        formData.set("page",page_)
        formData.set("size", size_)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/'+this.entity+'/list/',
            headers: {'Content-Type': 'application/json'},
        })
    }
    listWhitOutBuilding(page_,size_,type,search) {
        let formData=new FormData();
        formData.set("type",type)
        formData.set("search", search)
        formData.set("page",page_)
        formData.set("size", size_)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/'+this.entity+'/listWhitOutBuilding/',
            headers: {'Content-Type': 'application/json'},
        })
    }
    save(model) {
        return Api.save(this.entity,model)
    }
    checkOut(unitName,buildingId){
        let formData=new FormData();
        formData.set("unitName",unitName)
        formData.set("buildingId", buildingId)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/'+this.entity+'/checkOut/',
            headers: {'Content-Type': 'application/json'},
        })
    }


    // search(value,page_,size_,active){
    //     let search=value;
    //     let formData=new FormData();
    //     formData.set("page",page_)
    //     formData.set("size", size_)
    //     formData.append("search",search,)
    //     formData.append("active",active,)
    //     return BaseApi({requiresAtuh: true})({
    //         method: 'POST',
    //         data:formData,
    //         url: '/private/'+this.entity+'/search',
    //         headers: {'Content-Type': 'application/json'},
    //     })
    // }

    changeStatus(model){
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:model,
            url: '/private/'+this.entity+'/changeStatus',
            headers: {'Content-Type': 'application/json'},
        })
    }
    //کاربران غیرفعال
    getPageInactive(page_,size_,type,search) {
        let formData=new FormData();
        formData.set("type",type)
        formData.set("search", search)
        formData.set("page",page_)
        formData.set("size", size_)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/'+this.entity+'/listInactive/',
            headers: {'Content-Type': 'application/json'},
        })
    }


    getUserList(page_,size_ ,buildingId,unitName) {
    var formData = new FormData();
    formData.set("page",page_)
    formData.set("size", size_)
    formData.set("buildId", buildingId)
    formData.set("unitName", unitName)
    return BaseApi({requiresAtuh: true})({
        method: 'POST',
        data: formData,
        url: '/private/'+this.entity+'/listUser/',
        headers: {'Content-Type': 'application/json'},
    })
    }

//
// getCurrentUser() {
//     return BaseApi({requiresAtuh: true})({
//         method: 'GET',
//         url: '/private/user/getUser/',
//         headers: {'Content-Type': 'application/json'},
//     })
//     }

    upload(file,buildingId) {
        let formData = new FormData();
        formData.set("file",file)
        formData.set("buildingId",buildingId)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/'+this.entity+'/saveByExcel/',
            headers: {'Content-Type': 'application/json'},
        })
    }



}
export default new User_se();
